import { render, staticRenderFns } from "./tabSpecialGoods.vue?vue&type=template&id=0244b40b&scoped=true&"
import script from "./tabSpecialGoods.vue?vue&type=script&lang=js&"
export * from "./tabSpecialGoods.vue?vue&type=script&lang=js&"
import style0 from "./tabSpecialGoods.vue?vue&type=style&index=0&id=0244b40b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244b40b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0244b40b')) {
      api.createRecord('0244b40b', component.options)
    } else {
      api.reload('0244b40b', component.options)
    }
    module.hot.accept("./tabSpecialGoods.vue?vue&type=template&id=0244b40b&scoped=true&", function () {
      api.rerender('0244b40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabSpecialGoods.vue"
export default component.exports